/*
 * Copyright (c) 2023 D2ArmorPicker by Mijago.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export enum ModOrAbility {
  WhisperOfDurance = 1000,
  WhisperOfChains,
  WhisperOfConduction,
  // WhisperOfShards,

  // WhisperOfHedrons = 1100,
  WhisperOfBonds = 1101,
  WhisperOfHunger,
  WhisperOfFractures,
  WhisperOfTorment,

  // VOID
  EchoOfExpulsion = 1200,
  EchoOfProvision,
  EchoOfPersistence,
  EchoOfLeeching,
  EchoOfDomineering,
  EchoOfDilation,
  EchoOfUndermining,
  EchoOfExchange,
  EchoOfInstability, //+10 str
  EchoOfObscurity, //+10rec
  EchoOfStarvation,
  //EchoOfHarvest,
  //EchoOfVigilance,
  //EchoOfRemnants,
  //EchoOfReprisal,

  // SOLAR
  EmberOfBenelovence = 1300,
  EmberOfBeams,
  EmberOfEmpyrean,
  EmberOfCombustion,
  EmberOfChar,
  EmberOfTempering,
  EmberOfEruption,
  EmberOfWonder,
  EmberOfSearing,
  EmberOfTorches,
  EmberOfMercy,

  SparkOfBrilliance = 1400,
  SparkOfFeedback,
  SparkOfDischarge,
  SparkOfFocus,
  SparkOfVolts,
  SparkOfResistance,
  SparkOfShock,

  // Artifact mods,

  // Strand
  ThreadOfFury = 1600,
  ThreadOfAscent,
  ThreadOfFinality,
  ThreadOfWarding,
  ThreadOfTransmutation,
  ThreadOfEvolution,
  ThreadOfBinding,
  ThreadOfGeneration,
  ThreadOfPropagation,

  // These names are mapped to the fragment hash
  WhisperOfImpetus = 537774543,

  // Prismatic
  FacetOfAwakening = 1700,
  FacetOfCourage,
  FacetOfDawn,
  FacetOfDefiance,
  FacetOfDevotion,
  FacetOfDominance,
  FacetOfGrace,
  FacetOfHonor,
  FacetOfJustice,
  FacetOfProtection,
  FacetOfPurpose,
  FacetOfRuin,
  FacetOfSacrifice,
}
